module.exports = __webpack_public_path__ + "static/media/lidcore-detection-5.e249b07c.jpg";